import { render, staticRenderFns } from "./ViewBvnModal.vue?vue&type=template&id=3f62bd30&scoped=true&"
import script from "./ViewBvnModal.vue?vue&type=script&lang=js&"
export * from "./ViewBvnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62bd30",
  null
  
)

export default component.exports